module.exports = __webpack_public_path__ + "static/media/Card_Cat.338f69eb.svg";